/**
 * Console Override for Qwixx Online
 * 
 * This file disables all console logging when imported.
 * Import this file early in the application startup to suppress all console output.
 */

// Save original console methods
const originalConsole = {
  log: console.log,
  debug: console.debug,
  info: console.info,
  warn: console.warn,
  error: console.error
};

// Define a no-op function
const noop = () => {};

// Override console methods to do nothing in production
if (process.env.NODE_ENV === 'production') {
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  // Keep warning and error for important messages
  // console.warn = noop;
  // console.error = noop;
  
  // Also override methods that might be used
  console.trace = noop;
  console.group = noop;
  console.groupEnd = noop;
  console.groupCollapsed = noop;
  console.count = noop;
  console.countReset = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.timeLog = noop;
  console.timeStamp = noop;
  console.profile = noop;
  console.profileEnd = noop;
  console.table = noop;
  console.dir = noop;
  console.dirxml = noop;
  console.assert = noop;
  
  // Log once that we're disabling logs
  originalConsole.info('[Console] Logging disabled');
}

// Export the original console methods in case they're needed
export const originalConsoleMethods = originalConsole;

// Export a function to restore console
export const restoreConsole = () => {
  console.log = originalConsole.log;
  console.debug = originalConsole.debug;
  console.info = originalConsole.info;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  console.info('[Console] Logging restored');
}; 